<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import Multiselect from 'vue-multiselect';
import moment from "moment";
import Calendar from '../views/calendario';
import Swal from '@/utils/ugm-swal';
import DashboardAdvance from './dashboard/advance';

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, Calendar, DashboardAdvance  },
    data() {
        return {
            title: "Inicio",
            items: [
                {
                text: "Inicio",
                href: "/"
                }
            ],
            paginatedData:[],
            colegioseleccionada: null,
            datoscolegios: [
            ],
            isLoading: false,
            eventos:[],
            asignados:[],
            syncingHubspotAnual: false,
            remappingCoordinadores: false
        };
    },
    computed: {
        esDirector() {
            return this.user && this.user.rol === 'Director';
        },
        puedeVerAccionesRapidas() {
            const rol = this.user && this.user.rol ? String(this.user.rol) : '';
            return rol !== '' && !['Laborante', 'Decana', 'Gastos', 'Director'].includes(rol);
        },
        puedeVerColegiosInicio() {
            return !this.esDirector;
        },
        puedeVerEventosInicio() {
            return !this.esDirector;
        },
        puedeVerResumenEventos() {
            return this.user && this.user.rol !== 'Laborante' && !this.esDirector;
        }
    },
    methods:{
        crear(tipo){
            localStorage.setItem('usuario',tipo);
            window.location.href = "/web/configuracion/crearusuario";
        },
        irCrearEvento(){
            window.location.href = "/web/configuracion/crearevento";
        },
        irCrearColegio(){
            window.location.href = "/web/configuracion/crearcolegio";
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        ver_colegio(rbd){
            localStorage.setItem('rbd_colegio',rbd);
            window.location.href = "/web/configuracion/colegios";
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        fetchColegios(query) {
            if (query.length < 3) return; // Buscar después de escribir al menos 3 letras
            this.isLoading = true;
            axios.get(`/api/colegios?search=${query}`)
                .then(response => {
                this.datoscolegios = response.data;
                })
                .catch(error => console.error(error))
                .finally(() => this.isLoading = false);
        },
        buscarColegio() {
            console.log('Colegio seleccionado:', this.colegioseleccionada);
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY HH:mm');
            return orden
        },
        async syncHubspotEventosAnio() {
            if (this.syncingHubspotAnual) {
                return;
            }

            const confirm = await Swal.fire({
                icon: 'question',
                title: 'Traer HubSpot (30 días)',
                text: 'Esto consultará actividades, contactos y colegios asociados de los últimos 30 días. ¿Deseas continuar?',
                showCancelButton: true,
                confirmButtonText: 'Sí, ejecutar',
                cancelButtonText: 'Cancelar',
            });

            if (!confirm.isConfirmed) {
                return;
            }

            this.syncingHubspotAnual = true;
            Swal.fire({
                title: 'Consultando HubSpot (30 días)...',
                html: 'Cargando actividades, contactos y colegios asociados de los últimos 30 días. Este proceso puede tardar varios minutos.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            try {
                const res = await axios.post('/api/sync_hubspot_eventos_anio', { solo_nuevos: false, days: 30, traer_todas: false });
                const totales = (res.data && res.data.totales) || {};
                const modo = (res.data && res.data.modo) || 'incremental';
                const days = (res.data && res.data.days) || 30;

                Swal.close();

                await Swal.fire({
                    icon: 'success',
                    title: 'Consulta completada',
                    html: `
                        <div style="text-align:left;">
                            <p class="mb-1"><strong>Ventana:</strong> últimos ${days} días</p>
                            <p class="mb-1"><strong>Modo:</strong> ${modo}</p>
                            <p class="mb-1"><strong>Actividades período:</strong> ${totales.actividades_periodo || totales.actividades_anio || 0}</p>
                            <p class="mb-1"><strong>Nuevas agregadas:</strong> ${totales.actividades_nuevas || 0}</p>
                            <p class="mb-1"><strong>Omitidas (ya existentes):</strong> ${totales.actividades_omitidas || 0}</p>
                            <p class="mb-1"><strong>Actividades sincronizadas ahora:</strong> ${totales.actividades_sincronizadas || totales.actividades_exportadas || 0}</p>
                            <p class="mb-1"><strong>Eventos locales creados:</strong> ${totales.eventos_locales_creados || 0}</p>
                            <p class="mb-1"><strong>Eventos locales actualizados:</strong> ${totales.eventos_locales_actualizados || 0}</p>
                            <p class="mb-1"><strong>Colegios únicos en corrida:</strong> ${totales.colegios_unicos_corrida || 0}</p>
                            <p class="mb-1"><strong>Contactos únicos en corrida:</strong> ${totales.contactos_unicos_corrida || 0}</p>
                            <p class="mb-1"><strong>Colegios únicos en BD:</strong> ${totales.colegios_unicos || 0}</p>
                            <p class="mb-1"><strong>Contactos únicos en BD:</strong> ${totales.contactos_unicos || 0}</p>
                            <p class="mb-1"><strong>Eventos con asistentes en BD:</strong> ${totales.eventos_con_asistentes || 0}</p>
                            <p class="mb-1"><strong>Asistentes persistidos en BD:</strong> ${totales.asistentes_persistidos || 0}</p>
                            <p class="mb-0"><strong>Asistentes nuevos persistidos ahora:</strong> ${totales.asistentes_persistidos_nuevos || 0}</p>
                        </div>
                    `,
                });
            } catch (error) {
                Swal.close();
                const mensaje = error?.response?.data?.mensaje || 'No se pudo ejecutar la consulta anual de HubSpot.';
                const detalleJson = error?.response?.data?.detalle || '';
                const detalleHttp = error?.response
                    ? `HTTP ${error.response.status}${error.response.statusText ? ' - ' + error.response.statusText : ''}`
                    : '';
                const detalle = detalleJson || detalleHttp || 'Revisa storage/logs/laravel.log para más detalle.';
                await Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    text: detalle,
                });
            } finally {
                this.syncingHubspotAnual = false;
            }
        },
        async remapCoordinadoresHubspotExistentes() {
            if (this.remappingCoordinadores) {
                return;
            }

            const confirm = await Swal.fire({
                icon: 'question',
                title: 'Corregir coordinadores',
                text: 'Se actualizarán coordinadores de eventos existentes según owner de HubSpot. ¿Continuar?',
                showCancelButton: true,
                confirmButtonText: 'Sí, corregir',
                cancelButtonText: 'Cancelar',
            });

            if (!confirm.isConfirmed) {
                return;
            }

            this.remappingCoordinadores = true;
            Swal.fire({
                title: 'Corrigiendo coordinadores...',
                html: 'Revisando eventos existentes y mapeando owner de HubSpot.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            try {
                const res = await axios.post('/api/remap_coordinadores_hubspot_existentes');
                const t = (res.data && res.data.totales) || {};
                Swal.close();

                await Swal.fire({
                    icon: 'success',
                    title: 'Remapeo completado',
                    html: `
                        <div style="text-align:left;">
                            <p class="mb-1"><strong>Eventos revisados:</strong> ${t.eventos_revisados || 0}</p>
                            <p class="mb-1"><strong>Actualizados por texto:</strong> ${t.actualizados_por_texto || 0}</p>
                            <p class="mb-1"><strong>Actualizados por HubSpot:</strong> ${t.actualizados_por_hubspot || 0}</p>
                            <p class="mb-0"><strong>Sin match:</strong> ${t.sin_match || 0}</p>
                        </div>
                    `,
                });
            } catch (error) {
                Swal.close();
                const mensaje = error?.response?.data?.mensaje || 'No se pudo completar el remapeo.';
                const detalle = error?.response?.data?.detalle || '';
                await Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    text: detalle,
                });
            } finally {
                this.remappingCoordinadores = false;
            }
        },
    },
    created(){
        if (this.esDirector) {
            return;
        }

        this.isLoading=true
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios;
                this.asignados = response.data.colegios.filter((item) =>
                    item.user_id==this.user.id
                );
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
        axios.get('/api/get_proximos_eventos').then(res=>{
            this.eventos=res.data.eventos;
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">

            <!-- Tarjeta de perfil -->
            <div :class="esDirector ? 'col-md-12' : 'col-md-3'">
                <div class="card shadow-sm overflow-hidden">
                    <div class="card-header-ugm d-flex align-items-center p-4">
                        <div class="avatar-circle mr-3">
                            <i class="mdi mdi-account font-size-24 text-white"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-white font-weight-bold">{{ user.name }}</h5>
                            <small class="text-white-50">{{ user.rol }}</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-2">
                            <i class="mdi mdi-email-outline mr-2" style="color:#252C5F;"></i>
                            <span class="text-muted font-size-13">{{ user.email }}</span>
                        </div>
                        <div class="d-flex align-items-center mb-1" v-if="puedeVerResumenEventos">
                            <i class="mdi mdi-calendar-check mr-2" style="color:#252C5F;"></i>
                            <span class="text-muted font-size-13">Eventos responsable: <strong>{{ eventos.filter(e => e.propietario === user.name).length }}</strong></span>
                        </div>
                        <div class="d-flex align-items-center" v-if="puedeVerResumenEventos">
                            <i class="mdi mdi-calendar-account mr-2" style="color:#252C5F;"></i>
                            <span class="text-muted font-size-13">Eventos coordinador: <strong>{{ eventos.filter(e => e.coordinador_evento === user.name).length }}</strong></span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Acciones rápidas + Buscar colegio -->
            <div class="col-md-9" v-if="!esDirector">
                <!-- Acciones rápidas -->
                <div class="card shadow-sm mb-3" v-if="puedeVerAccionesRapidas">
                    <div class="card-body py-3">
                        <p class="text-uppercase font-size-11 font-weight-bold mb-3" style="color:#252C5F; letter-spacing:0.06em;">Acciones rápidas</p>
                        <div class="quick-actions-grid">
                            <button class="btn btn-ugm-dark" @click="irCrearEvento()">
                                <i class="mdi mdi-calendar-plus mr-1"></i> Crear Evento
                            </button>
                            <button class="btn btn-ugm-dark" @click="irCrearColegio()">
                                <i class="mdi mdi-domain mr-1"></i> Crear Colegio
                            </button>
                            <button class="btn btn-ugm-dark" @click="crear('usuario')" v-if="user.rol=='SuperAdmin' || user.rol=='Admin' || user.rol=='Supervisor'">
                                <i class="mdi mdi-account-plus mr-1"></i> Crear Usuario
                            </button>
                            <button class="btn btn-ugm-dark" @click="crear('laborante')" v-if="user.rol=='SuperAdmin' || user.rol=='Admin'">
                                <i class="mdi mdi-account-hard-hat mr-1"></i> Crear Laborante
                            </button>
                            <button
                                class="btn btn-ugm-dark"
                                @click="syncHubspotEventosAnio"
                                :disabled="syncingHubspotAnual"
                                v-if="user.rol=='SuperAdmin'">
                                <i class="mdi mdi-cloud-sync mr-1"></i>
                                {{ syncingHubspotAnual ? 'Consultando HubSpot...' : 'Traer HubSpot (30 días)' }}
                            </button>
                            <button
                                class="btn btn-ugm-dark"
                                @click="remapCoordinadoresHubspotExistentes"
                                :disabled="remappingCoordinadores"
                                v-if="user.rol=='SuperAdmin'">
                                <i class="mdi mdi-account-sync mr-1"></i>
                                {{ remappingCoordinadores ? 'Corrigiendo coordinadores...' : 'Corregir Coordinadores Eventos' }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Buscar colegio -->
                <div class="card shadow-sm" v-if="puedeVerColegiosInicio">
                    <div class="card-body">
                        <p class="text-uppercase font-size-11 font-weight-bold mb-1" style="color:#252C5F; letter-spacing:0.06em;">Buscar Colegio</p>
                        <p class="text-muted font-size-13 mb-3">Ingrese nombre o RBD</p>
                        <div class="d-flex align-items-start">
                            <div class="flex-grow-1 mr-2">
                                <multiselect
                                    v-model="colegioseleccionada"
                                    :options="datoscolegios"
                                    :searchable="true"
                                    :loading="isLoading"
                                    :custom-label="customLabel"
                                    placeholder="Buscar colegio..."
                                    @search-change="fetchColegios"
                                    selectLabel="Presiona para seleccionar"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Presiona para remover"
                                >
                                    <template v-slot:noOptions><p class="mb-0">Escribe para buscar...</p></template>
                                    <template v-slot:noResult><p class="mb-0">Sin coincidencias</p></template>
                                </multiselect>
                            </div>
                            <button class="btn btn-ugm-dark" style="white-space:nowrap;" :disabled="!colegioseleccionada" @click="ver_colegio(colegioseleccionada.rbd)">
                                <i class="mdi mdi-magnify mr-1"></i> Ver
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-if="esDirector">
                <DashboardAdvance embedded />
            </div>

            <!-- Calendario -->
            <div class="col-md-12" v-if="puedeVerEventosInicio">
                <div class="card shadow-sm">
                    <div class="card-header-ugm px-4 py-3">
                        <h6 class="mb-0 text-white font-weight-bold">
                            <i class="mdi mdi-calendar-month mr-2"></i>Próximos Eventos
                        </h6>
                    </div>
                    <div class="card-body">
                        <Calendar/>
                    </div>
                </div>
            </div>

        </div>
    </Layout>
</template>

<style scoped>
.card-header-ugm {
    background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%);
}
.avatar-circle {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.btn-ugm-dark {
    background-color: #252C5F;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    transition: background 0.2s;
}
.btn-ugm-dark:hover:not(:disabled) {
    background-color: #1a1f44;
    color: #fff;
}
.btn-ugm-dark:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.quick-actions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
}

.quick-actions-grid .btn-ugm-dark {
    width: 100%;
    margin: 0;
    white-space: nowrap;
}
</style>
